import { Box } from "@mui/material";
import React from "react";

const Loader = () => {
    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                backgroundColor: "rgba(255,255,255,0.95)",
                zIndex: 999999,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "100vh",
                "@keyframes rotate": {
                    "0%": {
                        transform: "rotate(0deg)",
                    },
                    "100%": {
                        transform: "rotate(360deg)",
                    }
                }
            }}
        >
            <Box
                sx={{
                    width: {
                        xs: "100px",
                        md: "190px",
                    },
                    height: {
                        xs: "100px",
                        md: "190px",
                    },
                    margin: "auto",
                    borderRadius: "50%",
                    position: "relative",
                    top: "0",
                    bottom: "0",
                    "& img": {
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                    },
                    "& svg": {
                        animation: `rotate 3s linear infinite`,
                        width: {
                            xs: "120px",
                            md: "auto",
                        },
                    },
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="231"
                        height="231"
                        viewBox="0 0 231 231"
                        fill="none"
                    >
                        <path
                            d="M228 115.5C228 137.75 221.402 159.501 209.04 178.002C196.679 196.502 179.109 210.922 158.552 219.436C137.995 227.951 115.375 230.179 93.5523 225.838C71.7295 221.498 51.6839 210.783 35.9505 195.05C20.2171 179.316 9.50249 159.271 5.16166 137.448C0.820819 115.625 3.04869 93.0048 11.5636 72.4481C20.0784 51.8914 34.4978 34.3213 52.9984 21.9597C71.4989 9.59801 93.2496 3 115.5 3"
                            stroke="url(#paint0_angular_1798_49303)"
                            strokeWidth="5"
                        />

                        <defs>
                            <linearGradient id="paint0_angular_1798_49303">
                                <stop offset="0" stopColor="#FF2E65" stopOpacity="1" />
                                <stop offset="0.25" stopColor="#F1B04C" stopOpacity="1" />
                                <stop offset="0.5" stopColor="#95018D" />
                                <stop offset="0.75" stopColor="#FF2E65" stopOpacity="0.3" />
                                <stop offset="1" stopColor="#F1B04C" stopOpacity="0.09" />
                            </linearGradient>
                        </defs>
                    </svg>
                </Box>
                <img src="/images/gsl-loadericon.jpg" alt="" />
            </Box>
        </Box>
    )
}

export default Loader